import { TargetGroupEditModel } from "@playcharge/common/models/backend/target-groups/target-group-edit-model";
import { ApiTargetGroupsService } from "./../../services/api-target-groups.service";
import { inject, computed } from "@angular/core";
import {
    signalStore,
    withState,
    withComputed,
    withMethods,
    patchState,
    withHooks,
} from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { tap, pipe, filter, switchMap, Observable, iif } from "rxjs";
import {
    withRequestStatus,
    setPending,
    setFulfilled,
    setError,
} from "../extensions/request-status.feature";
import { withRouteParams } from "../extensions/route-params.feature";
import { TargetGroupsStore } from "./target-groups.store";
import { TargetGroupState } from "../../models/target-groups/target-group-state";
import { TargetGroupViewModel } from "@playcharge/common/models/backend/target-groups/target-group-view-model";

export type TargetGroupStore = InstanceType<typeof TargetGroupStore>;

export const TargetGroupStore = signalStore(
    { protectedState: false }, withState<TargetGroupState>({
        groupId: 0,
    }),
    withRouteParams({ groupId: (param) => Number(param) }),
    withRequestStatus(),
    withComputed(({ groupId }, targetGroupsStore = inject(TargetGroupsStore)) => ({
        group: computed(() => (groupId() ? targetGroupsStore.entityMap()[groupId()] : null)),
    })),
    withMethods(
        (
            store,
            targetGroupsStore = inject(TargetGroupsStore),
            apiTargetGroupsService = inject(ApiTargetGroupsService),
        ) => ({
            updateGroup(model: TargetGroupEditModel): Observable<TargetGroupViewModel> {
                return iif(
                    () => model.id === 0,
                    apiTargetGroupsService.create(model),
                    apiTargetGroupsService.update(model),
                ).pipe(tap((group) => targetGroupsStore.setGroup(group)));
            },
            loadGroup: rxMethod<number>(
                pipe(
                    filter((id) => !!Number(id) && !store.group()),
                    tap(() => patchState(store, setPending())),
                    switchMap((id) => {
                        return apiTargetGroupsService.getById(id).pipe(
                            tap({
                                next: (group) => {
                                    patchState(store, setFulfilled());

                                    targetGroupsStore.setGroup(group);
                                },
                                error: (error) => patchState(store, setError(error.error.error)),
                            }),
                        );
                    }),
                ),
            ),
        }),
    ),
    withHooks({
        onInit({ loadGroup, groupId }) {
            loadGroup(groupId);
        },
    }),
);
